import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

type PropTypes = {
  close: () => void;
  handleConfirmLogout: () => void;
  open: boolean;
};

export const ConfirmLogoutDialog = ({
  close,
  handleConfirmLogout,
  open,
}: PropTypes) => {
  const handleConfirmLogoutClick = () => {
    close();
    handleConfirmLogout();
  };
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Confirm Logout</DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmLogoutClick}
          fullWidth
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};
